<template>
    <ul class="flex justify-center items-center"
        v-if="links.length > 3"
    >
        <InertiaLink
            as="li"
            class="px-2 py-1 bg-gray-100 cursor-pointer"
            v-for="(item, key) in links" :key="key"
            :href="item.url ? item.url : '#'"
            :class="{
                ['rounded-l-md border'] : key == 0,
                ['border-t border-b border-r'] : key != 0 && key != links.length - 1,
                ['rounded-r-md border border-l-0'] : key == links.length - 1,
                ['bg-gray-300'] : item.active,
                ['hover:bg-gray-200'] : !item.active,
                ['opacity-50'] : item.url == null
            }"
            v-html="item.label"
        />
    </ul>
</template>

<script>
export default {
    props: ['links'],
}
</script>
